"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_addedValue",
                type: "uint256",
            },
        ],
        name: "increaseApproval",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class StandardTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StandardTokenFactory = StandardTokenFactory;
StandardTokenFactory.bytecode = _bytecode;
StandardTokenFactory.abi = _abi;
//# sourceMappingURL=StandardTokenFactory.js.map